import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import shiftService, { isValidShiftId } from "../services/shiftService";

const initialState = {
  list: [],
  loading: false,
  error: null,
  currentShift: null, // optionally store open shift
  summary: null,
};

const shiftSlice = createModule({
  name: "shift",
  initialState,

  reducers: {
    /* ===== TRIGGERS ===== */
    fetchList: (state) => {
      state.loading = true;
      state.error = null;
    },
    openShift: (state) => {
      state.loading = true;
      state.error = null;
    },
    closeShift: (state) => {
      state.loading = true;
      state.error = null;
    },
    validateShift: (state) => {
      state.loading = true;
      state.error = null;
    },
    cancelShift: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOpenShift: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSummary: (state) => {
      state.loading = true;
      state.error = null;
    },

    /* ===== RESULTS ===== */
    fetched: (state, payload) => {
      state.list = payload || [];
      state.loading = false;
    },

    setCurrentShift: (state, payload) => {
      state.currentShift = payload;
      state.loading = false;
    },

    setSummary: (state, payload) => {
      state.summary = payload;
      state.loading = false;
    },

    finish: (state) => {
      state.loading = false;
    },

    error: (state, payload) => {
      state.loading = false;
      state.error = payload || "An error occurred";
    },
  },

  sagas: (A) => ({
    /* ===== FETCH ALL SHIFTS (FILTER) ===== */
    *[A.fetchList]({ payload }) {
      try {
        const { data } = yield call(shiftService.filter, payload || {});
        yield put(A.fetched(data.body || data));
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
      }
    },

    /* ===== OPEN SHIFT ===== */
    *[A.openShift]({ payload }) {
      try {
        const { data } = yield call(shiftService.openShift, payload.data);
        yield put(A.setCurrentShift(data.body || data));
        yield put(A.finish());
        payload?.onSuccess?.(data.body || data);
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },

    /* ===== CLOSE SHIFT ===== */
    *[A.closeShift]({ payload }) {
      try {
        const { data } = yield call(
          shiftService.closeShift,
          payload.id,
          payload.data
        );
        yield put(A.setCurrentShift(data.body || data));
        yield put(A.finish());
        payload?.onSuccess?.(data.body || data);
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },

    /* ===== VALIDATE SHIFT ===== */
    *[A.validateShift]({ payload }) {
      try {
        const { data } = yield call(
          shiftService.validateShift,
          payload.id,
          payload.data,
        );
        yield put(A.setCurrentShift(data.body || data));
        yield put(A.finish());
        payload?.onSuccess?.(data.body || data);
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },

    /* ===== CANCEL SHIFT ===== */
    *[A.cancelShift]({ payload }) {
      try {
        const { data } = yield call(
          shiftService.cancelShift,
          payload.id,
          payload.reason
        );
        yield put(A.setCurrentShift(data.body || data));
        yield put(A.finish());
        payload?.onSuccess?.(data.body || data);
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },

    /* ===== GET OPEN SHIFT FOR COMMERCIAL ===== */
    *[A.fetchOpenShift]({ payload }) {
      try {
        const { data } = yield call(
          shiftService.getOpenShift,
          payload.commercialId,
          payload.pointOfSaleId
        );
        yield put(A.setCurrentShift(data.body || data));
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
      }
    },

    *[A.fetchSummary]({ payload }) {
      const shiftId = payload?.shiftId;
      if (!isValidShiftId(shiftId)) {
        const error = new Error("Choisissez une session de caisse valide.");
        yield put(A.setSummary(null));
        yield put(A.error(error.message));
        payload?.onError?.(error);
        return;
      }
      try {
        const { data } = yield call(
          shiftService.getSummary,
          shiftId
        );
        yield put(A.setSummary(data.body || data));
        payload?.onSuccess?.(data.body || data);
      } catch (e) {
        console.error(e);
        yield put(A.error(e.message));
        payload?.onError?.(e);
      }
    },
  }),
});

export default shiftSlice;
export const shiftActions = shiftSlice.actions;
